import { namespace } from 'vuex-class';

export const infodaycoUpload = namespace('infodayco/infodaycoUpload');
export const tutorials = namespace('infodayco/tutorials');
export const serviceModels = namespace('infodayco/serviceModels');
